module.exports = __webpack_public_path__ + "img/1574772522.0c69a3de.jpg";